import { render, staticRenderFns } from "./FactorDescribe.vue?vue&type=template&id=563240d5&scoped=true"
import script from "./FactorDescribe.vue?vue&type=script&lang=js"
export * from "./FactorDescribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563240d5",
  null
  
)

export default component.exports